module.exports = __webpack_public_path__ + "static/media/answer-a-pressed.96916e22.png";